const ADD_BOUNDARIES = 'ADD_BOUNDARIES';
const REMOVE_BOUNDARIES = 'REMOVE_BOUNDARIES';

export {
  ADD_BOUNDARIES,
  REMOVE_BOUNDARIES,
};
